import { jsx as _jsx } from "react/jsx-runtime";
import { cn } from "./cn.js";
export function Input({ error, className, ...rest }) {
    return (_jsx("input", { className: cn("fwfa-input", error && "is-error", className), "aria-invalid": error || undefined, ...rest }));
}
//# sourceMappingURL=Input.js.map